import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LetterrequestcustomerIgnoreService {

  constructor(private http: HttpClient) { }

GetCustomer(): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerIgnore/GetCustomer").pipe(
        map(data => {
          return data as Array<General_Interface>
        })
      )
  }


  Add(customer_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerIgnore/Add?customer_id=" + customer_id).pipe(
        map(data => {
          return data as any
        })
      )
  }


  Delete(id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerIgnore/Delete?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

}
